import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'fullcalendar';
import 'reflect-metadata';
import 'zone.js';
import { AppModule } from './app/app.module';
import './extensions';

platformBrowserDynamic().bootstrapModule(AppModule);
